export enum SearchWidgetThemeEnum {
  DEFAULT = '',
  HOME = 'home',
}
